import {
  TrackingV2GetDriverLocationQuery,
  TrackingV2GetDriverLocationQueryVariables
} from '@data/__generated__/types.main'
import useStatus from '@page-components/TrackV2/hooks/useStatus'
import {useApolloQuery} from 'apollo-hooks'
import gql from 'graphql-tag'
import {useRouter} from 'next/router'

export default function useDriverLocation() {
  const router = useRouter()
  const {orderId} = router.query
  const status = useStatus()

  const {order} = useApolloQuery<
    TrackingV2GetDriverLocationQuery,
    TrackingV2GetDriverLocationQueryVariables
  >({
    query: gql`
      query TrackingV2GetDriverLocation($orderId: ID!) {
        order(orderId: $orderId) {
          _id
          delivery {
            _id
            location
          }
        }
      }
    `,
    variables: {
      orderId: orderId as string
    },
    omit: !orderId || status !== 'delivery',
    fetchPolicy: 'cache-first',
    pollInterval: 10000
  })

  return order?.delivery?.location as {lat: number; lng: number}
}
